export function formatVatSuggestionConfidence(score: number | null | undefined): string {
  const n = Number(score ?? 0);
  if (!Number.isFinite(n)) return '0%';
  return `${Math.max(0, Math.min(100, Math.round(n * 100)))}%`;
}

export function vatSuggestionExplanation(rationale: Record<string, any> | null | undefined): string {
  const text = String(rationale?.explanation || '').trim();
  return text || 'Deterministic Revenue-aligned suggestion';
}
